import React from 'react';
import PropTypes from 'prop-types';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { connect } from 'react-redux';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
// import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { CommsSectionSummaryHeader } from './comms-section-summary-header';
import { fetchNotificationComms } from '../../../../crq/crq-list-actions';

const CommsSectionSummaryUnconnected = React.memo(
  ({
    sectionIndex,
    navigateToSection,
    open,
    key,
    toggleOpen,
    // sectionErrors,
    summarySectionRead,
    viewType,
    // hasErrors,
    formData,
    network, // for use in rescheduling
    impactValue, // for use in rescheduling
    notificationTitle,
    notificationDate,
    uid,
    notificationCommsSummaryDataDetailed,
    isEmpty,
  }) => {
    // const sectionHasErrors = hasErrors ? !isEmpty(sectionErrors) : false;
    let deailedData = [];
    let failureData = '';
    // let SentData = '';

    let commsHandlerDetailed = false;
    if (notificationCommsSummaryDataDetailed) {
      if (notificationCommsSummaryDataDetailed.comms_info) {
        commsHandlerDetailed = true;
      }
    }
    // if (!deailedData) {
    //   commsHandlerDetailed = false;
    // }

    if (isEmpty === false) {
      if (commsHandlerDetailed === true) {
        deailedData = notificationCommsSummaryDataDetailed
        && notificationCommsSummaryDataDetailed.comms_info;
        // SentData = `${
        //   notificationCommsSummaryDataDetailed
        //   && notificationCommsSummaryDataDetailed.count.successful
        // }/${
        //   notificationCommsSummaryDataDetailed
        //   && notificationCommsSummaryDataDetailed.count.Total
        // }`;
      }
    }

    return (
      <div className="section-summary">
        <CommsSectionSummaryHeader
          open={open}
          toggleOpen={toggleOpen}
          sectionIndex={sectionIndex}
          navigateToSection={navigateToSection}
          sectionTitle={notificationTitle}
          notificationTitle={notificationTitle}
          notificationDate={notificationDate}
          uid={uid}
          // sectionId={sectionId}
          viewType={viewType}
          summarySectionRead={summarySectionRead}
          // sectionHasErrors={sectionHasErrors}
          formData={formData} // Sending FormData as extra props to SectionSummaryHeader Component
          impactValue={impactValue} // sending for rescheduling changes
          network={network} // sending for rescheduling changes
        />
        {open && (
          <div className="summary-fields">
            <div className="initial-comms">
              <div className="width-50 initial-comms-font">Customer</div>
              <div className="width-50 initial-comms-font">Failure</div>
              {/* <div className="initial-comms-font">Sent</div> */}
            </div>
            {!isEmpty && commsHandlerDetailed && (
              <div>
                {deailedData.map((data, index) => {
                  if (data && data.customer_detail.status === 'Sent') {
                    failureData = 'No';
                  }
                  else if (data && data.customer_detail.status === 'Failed') {
                    failureData = 'Yes';
                  }
                  else if (data && data.customer_detail.status === 'Draft') {
                    failureData = 'N/A';
                  }
                  else {
                    failureData = 'Not Categorized';
                  }
                  return (
                    <div className="initial-comms-details">
                      <div className="width-50">{ data.customer_detail.customer_name}</div>
                      <div className="width-50">{failureData}</div>
                      {/* <div>{SentData}</div> */}
                    </div>
                  );
                })}
              </div>
            )}
            {/* {
              isEmpty && (
                <div className="view-crq-loader">
                  <LoadingSpinner />
                </div>
              )
            } */}
            {
              !commsHandlerDetailed && (
                <div className="view-crq-loader">
                  Unable to fetch the comms info details.
                  Please try again later.
                </div>
              )
            }
          </div>
        )}
      </div>
    );
  },
);

CommsSectionSummaryUnconnected.propTypes = {
  formData: formDataShape,
  sectionIndex: PropTypes.number,
  navigateToSection: PropTypes.func,
  open: PropTypes.bool,
  toggleOpen: PropTypes.func,
  // sectionErrors: PropTypes.objectOf(PropTypes.object),
  summarySectionRead: PropTypes.bool,
  viewType: PropTypes.string,
  // hasErrors: PropTypes.bool,
  // selectedNetwork: PropTypes.string,
  impactValue: PropTypes.string,
  network: PropTypes.string,
  key: PropTypes.string,
  notificationTitle: PropTypes.string,
  notificationDate: PropTypes.string,
  uid: PropTypes.string,
  isEmpty: PropTypes.bool,
  notificationCommsSummaryDataDetailed: PropTypes.arrayOf(PropTypes.object),
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  // as this is dispatch from an asynch request, we need to return it to catch any errors
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
  notificationCommsAPI: (params) => dispatch(fetchNotificationComms(params)),
});

const CommsSectionSummary = connect(mapDispatchToProps)(
  CommsSectionSummaryUnconnected,
);

export { CommsSectionSummary };
